import { createRouter, createWebHistory } from 'vue-router'

// Импорт страниц из новой папки
import HomePage from '../public/pages/HomePage.vue'

import AboutPage from '../public/pages/AboutPage.vue'
import PropertyMapPage from '../public/pages/property_map/PropertyMapPage.vue'
import PropertyList from '../public/pages/PropertyList.vue'

import PropertyDetail from '../public/pages/PropertyDetail.vue'
import AgencyList from '../public/pages/AgencyList.vue'
import AgencyDetail from '../public/pages/AgencyDetail.vue'
import DeveloperList from '../public/pages/DeveloperList.vue'
import DeveloperDetail from '../public/pages/DeveloperDetail.vue'
import StatisticPage from '../public/pages/StatisticPage.vue'
import NewsList from '../public/pages/NewsList.vue'
import NewsDetail from '../public/pages/NewsDetail.vue'
import ResidentialComplexShow from '../public/pages/ResidentialComplexShow.vue'
import PrivacyPolicy from '../public/pages/PrivacyPolicy.vue'
import { useSeo } from '../public/composables/useSeo'


const routes = [
  { path: '/', name: 'HomePage', component: HomePage },
  { path: '/about', name: 'AboutPage', component: AboutPage },
  { path: '/privacy', name: 'PrivacyPolicy', component: PrivacyPolicy },

  { path: '/public/properties', name: 'PropertyList', component: PropertyList },
  //{ path: '/public/properties/map', name: 'PropertyMapPage', component: PropertyMapPage },
  { path: '/public/properties/map', name: 'PropertyMapPage', component: PropertyMapPage },

  { path: '/public/properties/:id', name: 'PropertyDetail', component: PropertyDetail },
  { path: '/public/agencies', name: 'AgencyList', component: AgencyList },
  { path: '/public/agencies/:id', name: 'AgencyDetail', component: AgencyDetail },
  { path: '/public/developers', name: 'DeveloperList', component: DeveloperList },
  { path: '/public/developers/:slug', name: 'DeveloperDetail', component: DeveloperDetail },
  { path: '/public/properties/statistic', name: 'StatisticPage', component: StatisticPage },
  { path: '/public/news/:id', name: 'NewsDetail', component: NewsDetail },
  { path: '/public/news', name: 'NewsList', component: NewsList },
  {
    path: '/public/developers/:developer_id/residential_complexes/:id',
    name: 'ResidentialComplexShow',
    component: ResidentialComplexShow
  }
]

export const publicRouter = createRouter({
  history: createWebHistory(),
  routes
})


publicRouter.afterEach((to) => {
  console.log('🧭 Router afterEach fired for:', to.name)
  const { applySeoMeta } = useSeo()
  if (to?.name) {
    console.log('🎯 SEO update for:', to.name)
    applySeoMeta(to.name)
  }
})